import VueSocketIO from 'vue-3-socket.io';
import SocketIO from 'socket.io-client'

import store from "@/store";

const state = JSON.parse(localStorage.getItem('authPersistent'));
const authorization = state && state.token ? `${state.token}` : '';

const SocketInstance = new VueSocketIO({
    debug: true,
    connection: SocketIO(process.env.VUE_APP_CHAT_API_URL, {
        reconnection: true,
        reconnectionDelay: 500,
        maxReconnectionAttempts: Infinity,
        extraHeaders: {
            'Authorization': authorization,
        }
    }),
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
})

export default SocketInstance